<template>
  <com-page>
    <com-community-search @add="handleCreated" @search="handleSearch"></com-community-search>
    <com-card>
      <com-community-list ref="communityListRef"></com-community-list>
    </com-card>
  </com-page>
</template>

<script>

export default {
  data() {
    return {
      searchColumn: [
        {
          label: '小区名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '归属',
          prop: 'refBelongAgentName',
          type: 'input'
        },
        {
          label: '地区',
          prop: 'areaCodes',
          type: 'region'
        },
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      }
    }
  },
  methods: {
    handleCreated() {
      this.$router.push({ name: 'community-edit', params: { type: 'created' } })
    },
    handleSearch(val) {
      const params = {
        ...val,
        areaCodes: val.areaCodes ? val.areaCodes.join(',') : '',
      }
      if (val.regionId && val.regionId.length) {
        delete params.regionId
      }
      this.exportQuery = { pageIndex: 1, pageSize: 10000, ...params }
      this.$refs.communityListRef.search(params)
      console.log('search :>> ', params)
    }
  },
}
</script>
